import type { SxProps, Theme } from '@mui/material/styles';

import { USER_ASSIGNMENT_STATUS } from 'containers/admin/clients/client/tabs-components/products-tab/product/report-assignment/report-assignment.constants';

import type { UserAssignmentStatus } from 'containers/admin/clients/client/tabs-components/products-tab/product/report-assignment/report-assignment.constants';

export interface AssignmentUser {
  id: string | number;
  hasAccess?: boolean;
  [key: string]: unknown;
}

export const getBorderSx = (
  isFirst: boolean,
  isLast: boolean
): SxProps<Theme> => {
  if (isFirst && isLast) return {};
  if (isFirst) {
    return { borderBottomWidth: '1px', borderColor: 'tokens.navy.200' };
  }
  if (isLast) {
    return { borderTopWidth: '1px', borderColor: 'tokens.navy.200' };
  }

  return {
    borderTopWidth: '1px',
    borderBottomWidth: '1px',
    borderColor: 'tokens.navy.200',
  };
};

export const determineUserAssignmentStatus = (
  users: AssignmentUser[] | undefined
): UserAssignmentStatus => {
  if (!users || !users?.length) return USER_ASSIGNMENT_STATUS.NONE_ASSIGNED;

  const allHaveAccess = users.every((user) => user.hasAccess);
  const noOneHasAccess = users.every((user) => !user.hasAccess);

  if (allHaveAccess) return USER_ASSIGNMENT_STATUS.ALL_ASSIGNED;
  if (noOneHasAccess) return USER_ASSIGNMENT_STATUS.NONE_ASSIGNED;

  return USER_ASSIGNMENT_STATUS.PARTIALLY_ASSIGNED;
};

export const updateUserAccess = (
  users: AssignmentUser[],
  userId: string | number,
  hasAccess: boolean
): AssignmentUser[] =>
  users.map((user) =>
    Number(user.id) === Number(userId) ? { ...user, hasAccess } : user
  );

export const updateAllUsersAccess = (
  users: AssignmentUser[],
  hasAccess: boolean
): AssignmentUser[] => users.map((user) => ({ ...user, hasAccess }));
